import { CustomDataType } from "./CustomDataType";

export default CustomDataType;
